<template>
  <v-container fluid grid-list-xl>
    <v-app-bar dense elevation="0" color="transparent">
      <div class="text-lg-h5 ml-n4">My Statistics</div>
      <v-spacer></v-spacer>

      <v-chip class="primary lighten-4 primary--text text--darken-4">
        {{ userData.employee }}
      </v-chip>
    </v-app-bar>
    <div>
      <StatsView :data="allStats"></StatsView>
    </div>
    <v-row>
      <v-col cols="4">
        <v-card class="mt-4">
          <DoughnutChart v-if="doughnutData" :doughnutData="doughnutData" />
        </v-card>
      </v-col>
      <v-col cols="8">
        <div>
          <v-card class="mt-4">
            <MultiDataBarchart :multiData="MultiData" />
          </v-card>
        </div>
      </v-col>
    </v-row>
    <!-- graphs -->
    <!-- custom fields -->
  </v-container>
</template>

<script>
import StatsView from "../../../cassandra-dashboards/Stats/StatsView.vue";
import DoughnutChart from "../../../cassandra-dashboards/Charts/DoughnutChart.vue";
import MultiDataBarchart from "../../../cassandra-dashboards/Charts/MultiDataBarchart.vue";
import helpers from "@kinetics254/cassandra-base/utilities/helpers/helper.js";
import { AuthService } from "@kinetics254/cassandra-base/modules/auth";

export default {
  name: "Stats",
  components: { StatsView, MultiDataBarchart, DoughnutChart },
  data() {
    return {
      show: false,
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  mounted() {
    console.log(this.packages.includes("leave"));
    if (this.packages.includes("leave")) this.getApplications();
  },
  computed: {
    packages() {
      return [
        ...new Set(
          Object.keys(this.$store.getters).map((el) => el.split("/")[0])
        ),
      ];
    },
    caption() {
      const user = AuthService.user;
      return user.captions.pettycash_caption;
    },
    userData: function () {
      return this.$store.getters["auth/user"];
    },
    leaveApplications: function () {
      return this.$store.getters["leave/leaveGetter"]
        ? this.$store.getters["leave/leaveGetter"]("applications")
        : [];
    },
    allStats: function () {
      return [
        {
          count: this.leaveApplications ? this.leaveApplications.length : 0,
          name: "Leave Applications",
          avatarColor: "light-blue lighten-4",
          iconColor: "light-blue darken-4",
          icon: "ti-calendar",
          routePath: "/leave/application",
        },
      ];
    },
    LeaveStats() {
      return this.leaveApplications;
    },
    pieData() {
      return {
        labels: ["Leave"],
        data: [this.leaveApplications.length],
        title: "All Statistics",
        backgroundColor: ["Requisitions", "Open", "Pending"].map((el) =>
          helpers.stringToColour(el)
        ),
      };
    },
    doughnutData() {
      return {
        labels: ["Leave"],
        data: [this.leaveApplications.length],
        title: "All Statistics",
        backgroundColor: ["Requisitions", "Open", "Pending"].map((el) =>
          helpers.stringToColour(el)
        ),
      };
    },
    MultiData() {
      return {
        labels: this.months,
        data: {
          leaveData: this.months.map((el, index) => {
            return this.LeaveStats.filter(
              (item) => new Date(item.application_date).getMonth() === index
            ).length;
          }),
        },
      };
    },
  },
  methods: {
    getApplications: function () {
      const employeeNo = this.userData.employee;
      const data = { employeeNo };
      setTimeout(() => {
        this.$store.dispatch("leave/getApplications", data);
      }, 1000);
    },
  },
};
</script>

<style scoped>
@media (min-width: 960px) {
  .flex.md3.lg3-custom {
    width: calc(100% / 3);
    max-width: calc(100% / 3);
    flex-basis: calc(100% / 3);
  }
}
</style>
